import React, { useEffect, useState, Fragment, useRef } from "react";
import { connect } from "react-redux";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { doc, setDoc, collection, getFirestore } from "firebase/firestore";
import { getDatabase, ref, set, push } from "firebase/database";
import { secondaryApp } from "../cofig/firebase";
import { async } from "@firebase/util";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";
import { gain, gain_request, gain_user } from "../store/acion";
import Navbar from "../NavbarBack";

function Login(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const cancelButtonRef = useRef(null);
  const [data_gain, setdata_gain] = useState(false);

  const re_load = async () => {
    if (props.user == "fail") {
      await props.gain_request();
      await props.gain_user();
      await props.gain();
    } else {
      // console.log("yes>>>>>.",props.cbs);

      setdata_gain(true);
      // setteacher_data(props.cbs)
    }
  };

  useEffect(() => {
    re_load();
  });
  const google_login = async () => {
    const provider = new GoogleAuthProvider();
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        const { displayName, email, uid, photoURL } = result.user;
        let asd = await props.cbs.find((e) => e.uid == uid);

        if (asd == undefined) {
          const db = getFirestore();
          await setDoc(doc(db, "teachers", uid), {
            name: displayName,
            email: email,
            uid: uid,
            pic: photoURL,
            status: "online",
            accept: "yes",
          }).then(() => {
            localStorage.setItem("teacher_uid", uid);

            navigate("/topics", { state: uid });
          });
        } else if (asd) {
          if (asd.accept == "yes") {
            localStorage.setItem("teacher_uid", uid);
            navigate("/TeacherDashboard", { state: uid });
          } else {
            setOpen(true);
            // Not approved
          }
        }

        // ...
      })
      .catch((error) => {
        // ...
      });
  };

  const google_login_user = async () => {
    const provider = new GoogleAuthProvider();
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        const { displayName, email, uid, photoURL } = result.user;

        let asd = await props.user.find((e) => e.uid == uid);

        if (asd == undefined) {
          console.log("result", result);
          const db = getFirestore();
          await setDoc(doc(db, "users", uid), {
            name: displayName,
            email: email,
            uid: uid,
            pic: photoURL,
          }).then(async () => {
            localStorage.setItem("user_uid", uid);

            navigate("/Dashboard", { state: uid });
          });
        } else {
          localStorage.setItem("user_uid", uid);

          navigate("/Dashboard", { state: uid });
        }

        // ...
      })
      .catch((error) => {
        // ...
      });
  };

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="modelWidth relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full d-flex flex-column align-items-center justify-content-center">
                  <div className="bg-white px-4 pt-3 pb-2  d-flex flex-column align-items-center justify-content-center">
                    <ExclamationIcon
                      className="h-25 w-25 text-red-600"
                      aria-hidden="true"
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Login Alert
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Your Licence For Login is Cancelled!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-0 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="text-white mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-gray-700  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      OK
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Navbar />
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
        <div
          style={{ marginTop: 20 }}
          className="
      flex flex-col
      bg-white
      shadow-md
      px-4
      sm:px-6
      md:px-8
      lg:px-10
      py-8
      rounded-3xl
      w-90
      max-w-md
      
    "
        >
          <div className="font-medium self-center text-xl sm:text-3xl text-gray-800">
          Welcome to Rizzilience
          </div>
          <div
            style={{ width: "70%", textAlign: "center" }}
            className="mt-4 self-center text-l  text-gray-800 fw-bold"
          >
            Join us to learn from our experienced coaches on various topics

          </div>

          <div
            style={{
              width: "90%",
              textAlign: "justify",
              fontSize: 14,
              marginLeft: "5%",
            }}
            className="mt-4 text-gray-800 "
          >
          Unlock a passion, overcome a fear, learn a new skill or take your knowledge to higher heights{" "}
          </div>
          <div className="mt-10">
            <div className="flex flex-col mb-3">
              {/* <button onClick={()=>{google_login()}}>Google Login</button>
            <button onClick={()=>{google_login_user()}}>Google Login for user</button> */}
            </div>

            <div className="flex w-full">
              <button
                type="submit"
                className="
              flex
              mt-2
              items-center
              justify-center
              focus:outline-none
              text-white text-sm
              sm:text-base
              bg-blue-500
              hover:bg-blue-600
              rounded-2xl
              py-2
              w-full
              transition
              duration-150
              ease-in
            "
                onClick={() => google_login_user()}
              >
                <span className="mr-2 uppercase">Google Login User</span>
                <i className="fas fa-user-graduate text-white-900" />
              </button>
            </div>

            <div className="flex w-full">
              <button
                type="submit"
                className="
              flex
              mt-2
              items-center
              justify-center
              focus:outline-none
              text-white text-sm
              sm:text-base
              bg-blue-500
              hover:bg-blue-600
              rounded-2xl
              py-2
              w-full
              transition
              duration-150
              ease-in
            "
                onClick={() => google_login()}
              >
                <span className="mr-2 uppercase">Google Login Coach</span>
                <i class="fas fa-chalkboard-teacher"></i>
              </button>
            </div>
          </div>
        </div>
        <div
          className="flex justify-center items-center mt-6"
          style={{ marginBottom: 50 }}
        >
          {/* <a
          href="#"
          target="_blank"
          className="
        inline-flex
        items-center
        text-gray-700
        font-medium
        text-xs text-center
      "
        >
          <span className="ml-2">You don't have an account?</span>
        </a>
        <a href="#" className="text-xs ml-2 text-blue-500 font-semibold">
          Register now
        </a> */}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    cbs: state.current_stock,
    request: state.request,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gain_user: () => dispatch(gain_user()),
    gain_request: () => dispatch(gain_request()),
    gain: () => dispatch(gain()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
